export const ACCENTS = [
  { id: 'red', value: '#e10600', labelKey: 'accent.red' },
  { id: 'orange', value: '#f25c05', labelKey: 'accent.orange' },
  { id: 'amber', value: '#e2a100', labelKey: 'accent.amber' },
  { id: 'lime', value: '#7cb518', labelKey: 'accent.lime' },
  { id: 'green', value: '#1f8a4c', labelKey: 'accent.green' },
  { id: 'teal', value: '#0e8a78', labelKey: 'accent.teal' },
  { id: 'blue', value: '#1d4ed8', labelKey: 'accent.blue' },
  { id: 'indigo', value: '#3730a3', labelKey: 'accent.indigo' },
  { id: 'violet', value: '#7c3aed', labelKey: 'accent.violet' },
  { id: 'pink', value: '#db2777', labelKey: 'accent.pink' },
];

export const ACCENT_MAP = ACCENTS.reduce((map, accent) => {
  map[accent.id] = accent.value;
  return map;
}, {});

export const COLUMN_OPTIONS = [1, 3, 5, 7];

export const TEXT_SIZES = {
  s: '13px',
  m: '15px',
  l: '18px',
};

export const SPACING = {
  s: '32px',
  m: '36px',
  l: '46px',
};

export const DEFAULT_PREFERENCES = {
  title: 'Zippax',
  accent: 'red',
  columns: 3,
  textSize: 'm',
  spacing: 'm',
  showCompleted: true,
  completedPosition: 'keep',
  bullet: 'square',
  startOn: 'yesterday',
  showLines: true,
  theme: 'light',
  celebrations: true,
  sidebarOpen: false,
  language: 'en',
};
